export const gridSchema = {
    __schema: {
        queryType: {
            name: 'Query'
        },
        mutationType: {
            name: 'Mutation'
        },
        subscriptionType: null,
        types: [
            {
                kind: 'INTERFACE',
                name: 'GdFreelancer',
                description: '',
                fields: [
                    {
                        name: 'card',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdFreelancerCard',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'certificates',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'OBJECT',
                                        name: 'GdFreelancerCertificate'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'createTime',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'LocalDateTime',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'feedbacks',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'OBJECT',
                                    name: 'GdFreelancerFeedback',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'fio',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'freelancerId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'login',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'mainSkill',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdFreelancerSkill',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'rating',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Float',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'skills',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'OBJECT',
                                        name: 'GdFreelancerSkill'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdFreelancerStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'workCurrency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'CurrencyCode',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdFreelancerBase',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFreelancerFull',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdAd',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'adGroup',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdAdGroupTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'adGroupId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'bannerImage',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdImage',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'body',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'callouts',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'OBJECT',
                                    name: 'GdCallout',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaignId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'creative',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdCreative',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'domain',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'domainId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'dynamicDisclaimer',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flags',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'SCALAR',
                                    name: 'String',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'href',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'image',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdImage',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'index',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'isMobile',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'lastChange',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'LocalDateTime',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'linkTail',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'optsGeoFlag',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Boolean',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'optsNoDisplayHref',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Boolean',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'phoneFlag',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Boolean',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'recommendations',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'INTERFACE',
                                    name: 'GdRecommendation',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'reverseDomain',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'sitelinks',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'OBJECT',
                                    name: 'GdSitelink',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'sitelinksSetId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'stats',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdEntityStats',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'title',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'titleExtension',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdAdType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'vCardId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'yacontextCategories',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCPMBannerAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCPCVideoAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMCBannerAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdImageAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicAd',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdTextAd',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmVideoAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdTextAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmDealsCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdTextCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCampaignFlatStrategy',
                description: '',
                fields: [
                    {
                        name: 'budget',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdCampaignBudget',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'isAutoBudget',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'platform',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignPlatform',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignStrategyType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpa',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpaPerFilter',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyWeekBudget',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpaPerCamp',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgClick',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpcPerFilter',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpcPerCamp',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyWeekBundle',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyAvgCpm',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyRoi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyManual',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdRecommendation',
                description: '',
                fields: [
                    {
                        name: 'bid',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'cid',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'isApplicable',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'keys',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'OBJECT',
                                        name: 'GdRecommendationKey'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'pid',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdRecommendationStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'timestamp',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdiRecommendationType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'userKey1',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'userKey2',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'userKey3',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationWithoutKpi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationWithKpi',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdShowCondition',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdShowConditionAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'adGroup',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdAdGroupTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'adGroupId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'adsInAdGroupCount',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaignId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'index',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'mainAd',
                        description: null,
                        args: [],
                        type: {
                            kind: 'INTERFACE',
                            name: 'GdAd',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'stats',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdEntityStats',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdShowConditionStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdShowConditionType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdRelevanceMatchSearch',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdKeyword',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdRecommendationSummary',
                description: '',
                fields: [
                    {
                        name: 'campaignIds',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'Long'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'isApplicable',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'keys',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'OBJECT',
                                        name: 'GdRecommendationKey'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdRecommendationStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'totalCount',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdiRecommendationType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationSummaryWithKpi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationSummaryWithoutKpi',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdApiResponse',
                description: '',
                fields: [
                    {
                        name: 'validationResult',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdValidationResult',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceAdsHrefPreviewPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFreelancerCardRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAcceptFlServiceByFreelancerRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFreelancerPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFreelancerSkillsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAddAdGroupMinusKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRequestFlServiceByClientRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDeleteFreelancerFeedbackPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSetBidsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDeleteFeedbackCommentPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFeedbackCommentPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceKeywordsPreviewPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFlStatusRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAddKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSuspendKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSetAutoBidsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCancelFlServiceByFreelancerRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAddFeedbackForFreelancerPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAddFeedbackCommentPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceAdsHrefPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCancelFlServiceByClientRequestPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdAddFreelancerPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUnsuspendKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDeleteKeywordsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUpdateFreelancerFeedbackPayload',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdAdIds',
                description: '',
                fields: [
                    {
                        name: 'adIds',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'SCALAR',
                                    name: 'Long',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceAdsHrefPreviewPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceAdsHrefBase',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceAdsHrefParams',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdSmartAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdMobileContentAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'storeHref',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdDynamicCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdMobileContentCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdSmartCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCpmBannerCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdAdGroup',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'availableAdTypes',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'ENUM',
                                        name: 'GdAdType'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'availableShowConditionTypes',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'ENUM',
                                        name: 'GdShowConditionType'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaignId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'index',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'multipliersBounds',
                        description: null,
                        args: [],
                        type: {
                            kind: 'OBJECT',
                            name: 'GdAdGroupMultipliersBounds',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'recommendations',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'INTERFACE',
                                    name: 'GdRecommendation',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'stats',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdEntityStats',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'tags',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdAdGroupType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmVideoAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdTextAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerAdGroup',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCpmVideoAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmVideoAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdTextAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdTextAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdMcBannerCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCampaign',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'agencyId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'agencyUserId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'availableAdGroupTypes',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'ENUM',
                                        name: 'GdAdGroupType'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'hasAds',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'index',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'managerUserId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'recommendations',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'INTERFACE',
                                    name: 'GdRecommendation',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'stats',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdEntityStats',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'sum',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'BigDecimal',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'tags',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'walletId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'Long',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMobileContentCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSmartCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmDealsCampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdTextCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdKeywordIds',
                description: '',
                fields: [
                    {
                        name: 'keywordIds',
                        description: null,
                        args: [],
                        type: {
                            kind: 'LIST',
                            name: null,
                            ofType: {
                                kind: 'NON_NULL',
                                name: null,
                                ofType: {
                                    kind: 'SCALAR',
                                    name: 'Long',
                                    ofType: null
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdSetBids',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSuspendKeywords',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSetBidsPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceKeywords',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdFindAndReplaceKeywordsPreviewPayload',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdUnsuspendKeywords',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdDeleteKeywords',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSetAutoBids',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdSetAutoBidsPayload',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCpmDealsCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmDealsCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdDynamicAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'mainDomain',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdDynamicAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdProject',
                description: '',
                fields: [
                    {
                        name: 'clientId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'createdTime',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'LocalDateTime',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'freelancer',
                        description: null,
                        args: [],
                        type: {
                            kind: 'INTERFACE',
                            name: 'GdFreelancer',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'freelancerId',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'startedTime',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'LocalDateTime',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdFreelancerProjectStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'updatedTime',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'LocalDateTime',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdFreelancerProject',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdClientProject',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdRecommendationKpi',
                description: '',
                fields: [
                    {
                        name: 'clicks',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'BigDecimal',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'cost',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'BigDecimal',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'CurrencyCode',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'graph',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdRecommendationKpiGraph',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'period',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Int',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'sign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdRecommendationSign',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationKpiDailyBudget',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationKpiSwitchOnAutotargeting',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationKpiRemovePagesFromBlackListOfACampaign',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdRecommendationKpiRemovePagesFromBlackList',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdTextCampaignTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'currency',
                        description: null,
                        args: [],
                        type: {
                            kind: 'ENUM',
                            name: 'CurrencyCode',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'flatStrategy',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignFlatStrategy',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdCampaignStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'type',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'GdCampaignType',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdTextCampaign',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdCpmBannerAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCpmBannerAdGroup',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'INTERFACE',
                name: 'GdMcBannerAdGroupTruncated',
                description: '',
                fields: [
                    {
                        name: 'access',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupAccess',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'campaign',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'INTERFACE',
                                name: 'GdCampaignTruncated',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'id',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Long',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'minusKeywords',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'LIST',
                                name: null,
                                ofType: {
                                    kind: 'NON_NULL',
                                    name: null,
                                    ofType: {
                                        kind: 'SCALAR',
                                        name: 'String'
                                    }
                                }
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'name',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'String',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'regionsInfo',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupRegionsInfo',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: 'status',
                        description: null,
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'OBJECT',
                                name: 'GdAdGroupStatus',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdMcBannerAdGroup',
                        ofType: null
                    }
                ]
            }
        ],
        directives: [
            {
                name: 'include',
                description:
                    'Directs the executor to include this field or fragment only when the `if` argument is true',
                locations: ['FIELD', 'FRAGMENT_SPREAD', 'INLINE_FRAGMENT'],
                args: [
                    {
                        name: 'if',
                        description: 'Included when true.',
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        defaultValue: null
                    }
                ]
            },
            {
                name: 'skip',
                description: "Directs the executor to skip this field or fragment when the `if`'argument is true.",
                locations: ['FIELD', 'FRAGMENT_SPREAD', 'INLINE_FRAGMENT'],
                args: [
                    {
                        name: 'if',
                        description: 'Skipped when true.',
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        defaultValue: null
                    }
                ]
            },
            {
                name: 'defer',
                description: 'This directive allows results to be deferred during execution',
                locations: ['FIELD'],
                args: []
            }
        ]
    }
};
